module.exports = __webpack_public_path__ + "img/category-favorite.e8376484.png";